import { DateTime } from 'luxon';
import axios from 'smg/axios';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import * as models from 'smg/models';
import * as template from 'smg/template';
import { PageLoader } from '../account';
import { Relref } from '../hugo';

declare interface carrierResp {
    carriers: models.Carrier[];
}

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const carriers = await axios.get<carrierResp>('/carriers').then(resp => resp.data.carriers);
    const carriersMap = new Map<number, models.Carrier>();
    for (const carrier of carriers) {
        if (carrier.id) {
            carriersMap.set(carrier.id, carrier);
        }
    }

    const pl: PageLoader<models.Shipment> = new PageLoader<models.Shipment>({
        get: () => axios.get<hyejoo.Shipments>('/shipments', {
            params: {
                'sort': pl.Sort(),
                'max': pl.CurrentPageSize(),
                'data': 'order, created, trackingNumber, carrierId, shipped, delivered',
                'p': pl.CurrentPage(),
                'q': pl.Search(),
            },
        }).then(resp => ({ rows: resp.data.shipments, nextPage: resp.data.nextPage })),
        draw: order => {
            const shipmentEl = template.Clone('#trackingInformation');

            // Place order/invoice numbers and adding appending the order link
            const orderNumberField = shipmentEl.querySelector('.order-number') as HTMLElement;
            const orderNumberLink = shipmentEl.querySelector('.order-link') as HTMLAnchorElement;
            orderNumberField.textContent = order.order?.invoiceNumber?.toString() || '';
            orderNumberLink.href += order.order?.invoiceNumber?.toString() || '';

            // Place order date. shipment.created
            const orderDate = shipmentEl.querySelector('.order-date') as HTMLElement;
            orderDate.textContent = DateTime.fromISO(order.created || '').toLocaleString(DateTime.DATE_SHORT);

            // Place tracking number
            const trackingNumberField = shipmentEl.querySelector('.shipment-tracking-number') as HTMLElement;
            trackingNumberField.textContent = order.trackingNumber || '';

            // Place the ship carrier
            const carrierFields = shipmentEl.querySelector('.shipment-carrier') as HTMLElement;
            if (order.carrierID) { // Wrapped in an 'if' because the carrier id on the shipments obj might be undefined
                carrierFields.textContent = carriersMap.get(order.carrierID)?.name || '';
            }

            // Place status field
            const statusField = shipmentEl.querySelector('.shipment-status') as HTMLElement;
            if (order.delivered) { // If the key 'delivered' exists on that index of the shipments object, text context would be 'delivered'
                statusField.textContent = `Delivered ${DateTime.fromISO(order.delivered).toLocaleString(DateTime.DATE_SHORT)}`; // Found this function in orders.ts
            } else if (order.shipped) {
                statusField.textContent = `Shipped ${DateTime.fromISO(order.shipped).toLocaleString(DateTime.DATE_SHORT)}`;
            } else {
                statusField.parentElement?.parentElement?.remove();
            }

            // Place the href with appended link w/ tracking number. First determine the carrier link
            const trackingLinksField = shipmentEl.querySelector('.tracking-link') as HTMLAnchorElement;
            const carrierLink = carriersMap.get(order.carrierID || 0)?.link;
            trackingLinksField.href = carrierLink?.replace('%%', order.trackingNumber || '') || '';

            return shipmentEl;
        },

    });

    pl.Load();
}